angular.module('iconoglobe')
.factory('photoGallery', function($http) {
    return {
        getPhotoGallery: function() {
            return $http.get('/api/getuserphotos');
        }
    };
})
.factory('audioGallery', function($http) {
    return {
        getAudioGallery: function(offset, offset2) {
        return $http.get('/api/getuseraudios/'+ offset);
        }
    };
})
.factory('videoGallery', function($http) {
    return {
        getVideoGallery: function(offset, offset2) {
            return $http.get('/api/getuservideos/'+ offset);
        }
    };
})
.factory('SharedData', function() {
    var list = [];
    return {
        addItem: addItem,
        getList: getList,resetList: resetList
    };
    function addItem(item) {
        list.push(item);
    }
    function getList() {
        return list;
    }
    function resetList() {
        list = [];
    }
})
.service('httpCanceler',['$http',  function($http){
    
    this.cancelRequest = function(url){
        var pendingRequests = $http.pendingRequests
        angular.forEach(pendingRequests, function(request) {
            if(request.url == url){
                request.cancel.resolve();
            }
         });
    }
}])
.service('promiseHandler',[function(){
    var promiseObject, start;
    
    this.updatePromise = function(p){
        // promiseObject = p;
        // promiseObject.resolve();
    }
    this.checkDebounce = function(){
        // if(start && new Date() - start < 150){
        //console.log(new Date() - start);
        //     promiseObject.resolve();
        // } 
        // start = new Date();
    }
}]);
